module.exports = __webpack_public_path__ + "static/media/ic_show_aos.c945b1ad.svg";